import '.a{display:flex;}.ssr-plugin'
import '.dn{aspect-ratio:1/1;}.ssr-plugin'
import '.bo{flex-shrink:0;}.ssr-plugin'
import '.do{padding:0.5rem;}.ssr-plugin'
import '.dp{border-radius:0.625rem;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style, styled } from 'inlines'

type Variant = 'red' | 'blue' | 'gray'

const variantStyle: Record<Variant, Style> = {
  red: {
    color: 'var(--primary-red)',
    background: '#FFE3E233',
  },
  blue: {
    color: 'var(--primary-blue)',
    background: '#D9EEFF',
  },
  gray: {
    color: 'var(--primary-blue)',
    background: 'var(--shades-blue-100)',
  },
}

const sizeStyle: Record<
  string,
  { width: string; height: string; iconFontSize: string }
> = {
  'extra-small': {
    width: '1.5rem',
    height: '1.5rem',
    iconFontSize: '1rem',
  },
  small: {
    width: '2rem',
    height: '2rem',
    iconFontSize: '1rem',
  },
  medium: {
    width: '3rem',
    height: '3rem',
    iconFontSize: '1.5625rem',
  },
  large: {
    width: '4rem',
    height: '4rem',
    iconFontSize: '2.5rem',
  },
}

export type IconProps = {
  variant?: Variant
  icon?: IconProp
  style?: Style
  size?: keyof typeof sizeStyle
}

export const Icon = ({ variant, icon, style, size = 'medium' }: IconProps) => {
  return (
    <styled.div className="a dn bo do dp b f"
      style={{
        width: sizeStyle[size].width,
        height: sizeStyle[size].height,
        ...(variant ? variantStyle[variant] : {}),
        ...style,
      }}
    >
      <FontAwesomeIcon icon={icon} fontSize={sizeStyle[size].iconFontSize} />
    </styled.div>
  )
}
